const modalCreateNote = {
  header: 'Criar nota',
  btnCancel: 'Cancelar',
  btnOk: 'Ok',
};

export default modalCreateNote;
